<div class="cell auto" *ngIf="parameters">
    <kiwi-parameters-tab-content-header
        [saveDisabled]="areParametersReadonly()"
        (saved)="updateParameters()"
        [titleLabelKey]="'parameters.restaurant.sales.repartition.title'">
    </kiwi-parameters-tab-content-header>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <p [i18nKey]="'parameters.restaurant.sales.repartition.description'"></p>

    <kiwi-spacer [size]="8"></kiwi-spacer>

    <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th></th>
            <th [i18nKey]="'parameters.restaurant.sales.repartition.a.la.carte.proportion'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'menu.first.course'"></td>
            <td>
                <kiwi-percentage-input [(ngModel)]="parameters.aLaCarteFirstCoursesProportion"
                                       [disabled]="areParametersReadonly()">
                </kiwi-percentage-input>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'menu.main.course'"></td>
            <td>
                <kiwi-percentage-input [(ngModel)]="parameters.aLaCarteMainCoursesProportion"
                                       [disabled]="areParametersReadonly()">
                </kiwi-percentage-input>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'menu.dessert'"></td>
            <td>
                <kiwi-percentage-input [(ngModel)]="parameters.aLaCarteDessertsProportion"
                                       [disabled]="areParametersReadonly()"></kiwi-percentage-input>
            </td>
        </tr>
        </tbody>
    </table>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <p [i18nKey]="'parameters.restaurant.sales.repartition.wines.sales.description'"></p>

    <table class="_tableColor">
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.restaurant.sales.repartition.covers.number.per.bottle'"></td>
            <td>
                <input [(ngModel)]="parameters.coversNumberPerBottle"
                       [disabled]="areParametersReadonly()" type="number">
            </td>
        </tr>
        </tbody>
    </table>
</div>
